import { UPDATE_FIELDS, GENERAL_DETAILS } from "../../annotation/PlanningConstants";
import { fetchRelocationDetails } from "./SetRelocationDetails";
import { getCityNameInEnglish } from "./helper";

export const SetAddressData = async (data: any, dispatch: any, state: any) => {
  let { street, nr, bus, postal, city, country, coordinates } = data;

  //*** set lat and lang */
  let lat = "";
  let lng = "";

  if (coordinates !== "") {
    [lat, lng] = coordinates
      .replace("Lat: ", "")
      .replace("Lng: ", "")
      .split(", ");
  }

  // Match country with case-insensitive comparison
  if (country !== "") {
    country = state.dropDowndata.countryOptions.find((option: any) =>
      option.label.toLowerCase().includes(country.toLowerCase())
    );
  }

  // If country matches, filter cities by removing prefixes and using case-insensitive comparison
  // if (country && country.value === 29 && city !== "") {
  //   const normalizedCity = getCityNameInEnglish(city);

  //   city = state.dropDowndata?.cityOptions.find((option: any) =>
  //     option.label?.toLowerCase().includes(normalizedCity?.toLowerCase()) || null
  //   )
  // };
  city = {value: city, label: `${postal} - ${city}`};

  const addressData = {
    street: street,
    number: nr,
    city: city,
    country: country,
    zipCode: postal,
    box: bus,
    lat: parseFloat(lat),
    lng: parseFloat(lng),
    // cityOther: country === "" || (country && country.value !== 29) ? city : "",
  }
  await fetchRelocationDetails(state.basicDetails.partiarCommittee?.value,
    state.basicDetails.branch.value,
    state.basicDetails.collegue?.value,
    dispatch, false, false, state.remenurationDetails.typeOfTransport?.value, state.planningId, addressData);

  Object.entries(addressData).forEach(([key, value]) => {
    dispatch({
      type: UPDATE_FIELDS,
      tab: GENERAL_DETAILS,
      field: key,
      value: value,
    });
  });
};
